import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=06579d5b&scoped=true&"
import script from "./js/Index.js?vue&type=script&lang=js&"
export * from "./js/Index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=06579d5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06579d5b",
  null
  
)

export default component.exports